import React, { useState, useEffect } from "react";
import { getAllMPStainlessSteelTables } from '../../services/tables/MPStainlessSteelTableService';
import MPStainlessSteelTable from "../../components/tecnical-sheets/MPStainlessSteelTable";
import Notify from "../../components/global/Notify";
import { Backdrop, CircularProgress, Box } from "@mui/material";

const MPStainlessSteelTablePage = () => {

    const page = 0;
    const rowsPerPage = 20;
    const [searchString, setSearchString] = useState('');
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const res = await getAllMPStainlessSteelTables(page, rowsPerPage, searchString);
                setRows(res.content);
                setLoading(false);
            } catch (error) {
                notify(error.message, false);
            }
        })();
    }, [page, rowsPerPage, searchString]);

    const notify = (message, isSucessMessage) => {
        if (isSucessMessage) {
            Notify.success(message);
        } else {
            Notify.error(message);
        }
    };

    const onSearchChange = (search) => {
        setSearchString(search);
    }

    return (
        <>
            <Box sx={{ position: "relative", width: "98%" }}>
                <MPStainlessSteelTable
                    rows={rows}
                    onSearchChange={onSearchChange}
                />

                <Backdrop
                    open={loading}
                    sx={{
                        position: "absolute",
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        color: "#04642c",
                        zIndex: 1,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <CircularProgress color="inherit" size={40} />
                </Backdrop>
            </Box>
        </>
    );
}
export default MPStainlessSteelTablePage;
